import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook to update the page title on route change.
 * @param {string} title - The title to set for the document.
 */
function usePageTitle(title) {
  const location = useLocation();

  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [location.pathname, title]);
}

export default usePageTitle;